// client/src/components/shared/TopNavBar.tsx

import React from "react";
import { NavLink } from "react-router-dom";
import "../../assets/styles/shared.css";

const TopNavBar: React.FC = () => {
  return (
    <nav className="top-nav-bar">
      <ul>
        <li>
          <NavLink
            to="/"
            className={({ isActive }) => (isActive ? "active" : undefined)}
          >
            Home
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/about"
            className={({ isActive }) => (isActive ? "active" : undefined)}
          >
            About
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/contact"
            className={({ isActive }) => (isActive ? "active" : undefined)}
          >
            Contact
          </NavLink>
        </li>
        {/* Add additional links if necessary */}
      </ul>
    </nav>
  );
};

export default TopNavBar;
